import {useEffect, useState} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const useGetAccountParticipationTicketQRGenerate = (serial_number) => {
	const [fetchResult, fetchRequest, loading] = useFetch()
	const [isRefetch, setIsRefetch] = useState(false)
	const [, setAlert] = useAlertModalAtom()

	const refetch = () => {
		setIsRefetch((prev) => !prev)
	}

	useEffect(() => {
		if (serial_number)
			fetchRequest(
				'GET',
				`/account/participation-ticket/${serial_number}/qr-generate`
			)
	}, [serial_number, isRefetch])

	return [fetchResult, loading, refetch]
}

export default useGetAccountParticipationTicketQRGenerate
